export const AddonsPossibleValues = [
  'WINTERSPORTS',
  'BUSINESS',
  'GOLF',
  'TRAVELDISRUPTION',
  'ACTIVITIES',
];

export const OptionsPossibleValues = [
  'EXCESSWAIVER',
  'STANDARDEXCESS',
  'DOUBLEEXCESS',
];
